export default "__VITE_ASSET__DNSf524h__"